
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, 
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Component } from "@/utils/componentService";
import { useEffect, useState } from "react";

interface DeleteComponentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  component: Component | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export function DeleteComponentDialog({ 
  open, 
  onOpenChange, 
  component, 
  onConfirm,
  isLoading
}: DeleteComponentDialogProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  
  useEffect(() => {
    setInternalOpen(open);
  }, [open]);
  
  const handleConfirm = () => {
    onConfirm();
  };
  
  const handleOpenChange = (newOpen: boolean) => {
    if (isLoading) return;
    
    setInternalOpen(newOpen);
    if (!newOpen) {
      // Allow animation to complete before notifying parent
      setTimeout(() => {
        onOpenChange(false);
      }, 100);
    } else {
      onOpenChange(true);
    }
  };
  
  return (
    <AlertDialog open={internalOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir o componente "{component?.name}"?
            Esta ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? "Excluindo..." : "Excluir"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
